import { AlertIcon, BodyText, Brand, Chip, ChipRemovable, Heading } from '@farol-ds/react'
import classNames from 'classnames'

import { PRODUCTION_ORIGIN } from '../../constants'
import styles from './internal-header.module.scss'

export interface InternalHeaderSubtitle {
  content: React.ReactNode
  asChild?: boolean
}

export interface InternalHeaderProps {
  title?: React.ReactNode
  subtitle?: InternalHeaderSubtitle
  errorMessage?: {
    title?: string
    description?: string
  }
  chip?: {
    text: string
    onClose?: () => void
  }
  align?: 'start' | 'center'
  className?: string
}

export const InternalHeader = ({
  title,
  subtitle,
  errorMessage,
  chip,
  align = 'start',
  className,
}: InternalHeaderProps) => {
  return (
    <div
      className={classNames(
        styles.internalHeader,
        { [styles.internalHeaderCentered]: align === 'center' },
        className
      )}
    >
      <div className={styles.internalHeaderBrand}>
        <a
          href={PRODUCTION_ORIGIN}
          aria-label="Voltar para página principal Jusbrasil"
          className={styles.internalHeaderBrandLink}
        >
          <Brand width={40} height={40} onlySymbol />
        </a>
      </div>

      <div className={styles.internalHeaderMain}>
        {title && (
          <Heading size="lg" className={styles.internalHeaderTitle} asChild>
            <h1>{title}</h1>
          </Heading>
        )}
        {subtitle && (
          <BodyText size="lg" className={styles.internalHeaderSubtitle} asChild={subtitle.asChild}>
            {subtitle.content}
          </BodyText>
        )}
        {errorMessage?.title && (
          <div
            className={classNames(
              styles.internalHeaderErrorMessage,
              errorMessage.description && styles.internalHeaderErrorMessageWithDescription
            )}
          >
            <div className={styles.internalHeaderErrorMessageRow}>
              <AlertIcon className={styles.internalHeaderErrorMessageIcon} />
              <span className={styles.internalHeaderErrorMessageTitle}>{errorMessage.title}</span>
            </div>
            {errorMessage.description && (
              <div className={styles.internalHeaderErrorMessageDescriptionRow}>
                <span className={styles.internalHeaderErrorMessageDescription}>
                  {errorMessage.description}
                </span>
              </div>
            )}
          </div>
        )}
      </div>

      {chip &&
        (chip.onClose ? (
          <div className={styles.internalHeaderChipWrapper}>
            <ChipRemovable
              className={styles.internalHeaderChip}
              onRemove={chip.onClose}
              unstable_truncate={true}
              title={chip.text}
            >
              {chip.text}
            </ChipRemovable>
          </div>
        ) : (
          <div className={styles.internalHeaderChipWrapper}>
            <Chip className={styles.internalHeaderChip} unstable_truncate={true} title={chip.text}>
              {chip.text}
            </Chip>
          </div>
        ))}
    </div>
  )
}
